import React, { useEffect, useState, useContext } from 'react';
import { Container, Paper, TableHead, TableRow, TableCell, TableBody, Button, IconButton, TextField, MenuItem, Modal, Box } from '@mui/material';
import {
  StyledTableContainer,
  StyledTable,
  StyledTableHeadCell,
  StyledTableRow,
} from '../theme/tableStyles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import * as endPoints from '../assets/js/endpoints';
import { UserContext } from '../assets/contexts/userContext';
import { useNotification } from '../assets/contexts/notificationContext';
import { useConfirm } from '../assets/contexts/confirmContext';
import Calendar from '../pages/calendar';
import AddIcon from '@mui/icons-material/Add';
import { Helmet } from 'react-helmet';

const EmployeeAppointments = () => {
  // const { user } = useContext(UserContext);
  // const [appointments, setAppointments] = useState([]);
  // const [clients, setClients] = useState([]);
  // const [form, setForm] = useState({ date: '', time: '', client_id: '', notes: '' });
  // const [editingId, setEditingId] = useState(null);
  // const [shareOpen, setShareOpen] = useState(false);
  // const [selectedEmployee, setSelectedEmployee] = useState('');
  // const [shareId, setShareId] = useState(null);
  // const [employees, setEmployees] = useState([]);
  // const { showNotification } = useNotification();
  // const confirm = useConfirm();

  // const loadAppointments = async () => {
  //   try {
  //     const data = await endPoints.getAppointments();
  //     const own = Array.isArray(data) ? data.filter(a => (a.users || []).some(u => u.id === user.id)) : [];
  //     setAppointments(own);
  //     if (own.length === 0) {
  //       showNotification('Aún no tienes citas', 'info');
  //     }
  //   } catch (_err) {
  //   }
  // };

  // const loadClients = async () => {
  //   try {
  //     const clis = await endPoints.getClientsByEmployee(user.id);
  //     setClients(Array.isArray(clis) ? clis : clis.data);
  //   } catch (_err) {
  //   }
  // };

  // const loadEmployees = async () => {
  //   try {
  //     const data = await endPoints.getAllUsers();
  //     const emp = (Array.isArray(data) ? data : data.data).filter(e => (e.role || e.roles?.[0]?.name) === 'employee' && e.id !== user.id);
  //     setEmployees(emp);
  //   } catch (_err) {
  //   }
  // };

  // useEffect(() => {
  //   if (user.id !== null) {
  //     loadAppointments();
  //     loadClients();
  //     loadEmployees();
  //   }
  // }, [user.id]);

  // const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  // const handleSubmit = async e => {
  //   e.preventDefault();
  //   const payload = new FormData();
  //   payload.append('employee_ids[]', user.id);
  //   payload.append('date', form.date);
  //   payload.append('time', form.time.substring(0,5));
  //   payload.append('client_id', form.client_id);
  //   payload.append('notes', form.notes);
  //   try {
  //     if (editingId) {
  //       await endPoints.updateAppointment(editingId, payload);
  //     } else {
  //       await endPoints.createAppointment(payload);
  //     }
  //     setForm({ date: '', time: '', client_id: '', notes: '' });
  //     setEditingId(null);
  //     loadAppointments();
  //   } catch (_err) {
  //   }
  // };

  // const handleEdit = a => {
  //   setForm({
  //     date: a.date || '',
  //     time: (a.time || '').substring(0,5),
  //     client_id: a.client_id || '',
  //     notes: a.notes || '',
  //   });
  //   setEditingId(a.id);
  // };

  // const handleDelete = async id => {
  //   const ok = await confirm('¿Eliminar cita?');
  //   if (!ok) return;
  //   try {
  //     await endPoints.deleteAppointment(id);
  //     loadAppointments();
  //   } catch (_err) {
  //   }
  // };

  // const openShare = id => {
  //   setShareId(id);
  //   setShareOpen(true);
  //   if (employees.length === 0) loadEmployees();
  // };

  // const handleShare = async e => {
  //   e.preventDefault();
  //   if (!selectedEmployee || !shareId) return;
  //   try {
  //     await endPoints.shareAppointment(shareId, selectedEmployee);
  //     showNotification('Cita compartida', 'success');
  //     setShareOpen(false);
  //     setSelectedEmployee('');
  //     setShareId(null);
  //     loadAppointments();
  //   } catch (_err) {
  //     showNotification('Error compartiendo cita', 'error');
  //   }
  // };

  // return (
  //   <Container sx={{ mt: 3 }}>
  //     <Paper sx={{ p: 2, mb: 2 }}>
  //       <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
  //         <TextField label="Fecha" name="date" type="date" value={form.date} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
  //         <TextField label="Hora" name="time" type="time" value={form.time} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
  //         <TextField sx={{width:'16em'}} select label="Cliente" name="client_id" value={form.client_id} onChange={handleChange} required>
  //           {clients.map(c => (
  //             <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
  //           ))}
  //         </TextField>
  //         <TextField label="Notas" name="notes" value={form.notes} onChange={handleChange} />
  //         <Button type="submit" variant="contained">{editingId ? 'Actualizar' : 'Crear'}</Button>
  //       </form>
  //     </Paper>
  //     <StyledTableContainer component={Paper}>
  //       <StyledTable>
  //       <TableHead>
  //         <StyledTableRow>
  //           <StyledTableHeadCell>Fecha</StyledTableHeadCell>
  //           <StyledTableHeadCell>Hora</StyledTableHeadCell>
  //           <StyledTableHeadCell>Cliente</StyledTableHeadCell>
  //           <StyledTableHeadCell>Notas</StyledTableHeadCell>
  //           <StyledTableHeadCell sx={{display:'flex', textAlign:'center', }}>Acciones</StyledTableHeadCell>
  //         </StyledTableRow>
  //       </TableHead>
  //       <TableBody>
  //         {appointments.map(a => (
  //           <StyledTableRow key={a.id}>
  //             <TableCell>{a.date}</TableCell>
  //             <TableCell>{a.time}</TableCell>
  //             <TableCell>{a.client?.name || ''}</TableCell>
  //             <TableCell>{a.notes}</TableCell>
  //             <TableCell sx={{display:'flex', gap: 1, justifyContent:'center', alignSelf:'center'}}>
  //               <IconButton onClick={() => handleEdit(a)} color="secondary" size="small">
  //                 <EditIcon />
  //               </IconButton>
  //               <IconButton onClick={() => openShare(a.id)} color="primary" size="small">
  //                 <ShareIcon />
  //               </IconButton>
  //               <IconButton onClick={() => handleDelete(a.id)} color="error" size="small">
  //                 <DeleteIcon />
  //               </IconButton>
  //             </TableCell>
  //           </StyledTableRow>
  //         ))}
  //       </TableBody>
  //       </StyledTable>
  //     </StyledTableContainer>
  //     <Modal
  //       open={shareOpen}
  //       onClose={() => setShareOpen(false)}
  //       slotProps={{ backdrop: { onClick: () => setShareOpen(false) } }}
  //     >
  //       <Paper onClick={e => e.stopPropagation()} sx={{ p:2, m:'5% auto', width:{ xs:'90%', sm:400 } }}>
  //         <form onSubmit={handleShare} style={{ display:'flex', flexDirection:'column', gap:16 }}>
  //           <TextField select label='Empleado' value={selectedEmployee} onChange={e => setSelectedEmployee(e.target.value)} required>
  //             {employees.map(emp => (
  //               <MenuItem key={emp.id} value={emp.id}>{emp.name}</MenuItem>
  //             ))}
  //           </TextField>
  //           <Box sx={{ display:'flex', gap:2, justifyContent:'center' }}>
  //             <Button onClick={() => setShareOpen(false)}>Cancelar</Button>
  //             <Button type='submit' variant='contained'>Compartir</Button>
  //           </Box>
  //         </form>
  //       </Paper>
  //     </Modal>
  //   </Container>
  // );


  return (
    <>
      <Helmet>
        <title>Mis Citas | CES</title>
      </Helmet>
      <Container maxWidth="xl" sx={{ mt: 5,  paddingBottom: '3em' }}>
        <Calendar />
      </Container>
    </>
  );
};

export default EmployeeAppointments;
